<script>
import { fandomBasicMixin } from "src/modules/fandom_mixins_module.js";
import { kenwoodItalyBasicMixin, kenwoodItalyAuthorizationMixin } from "../../modules/kenwood_italy_mixins_module.js";
import { get } from "lodash";

const getFromCategory = (category, field, fallback) => get(globalState.pageModel.name_to_content, [category, field], fallback);

export default {
  mixins: [fandomBasicMixin, kenwoodItalyBasicMixin, kenwoodItalyAuthorizationMixin],
  methods: {
    getBackgroundUrl: Fandom.getBackgroundUrl,
    capitalize: Fandom.capitalize
  },
  computed: {
    contentUrl() {
      const url = get(this, ["content", "url", "url"], this.content.slug);
      return Fandom.applyContextToUrl(url);
    },
    owner() {
      const owner = get(this, ["content", "owned_by"], false);
      return owner && get(globalState, ["pageModel", "id_to_user", owner], false);
    },
    categoryTitle() {
      return getFromCategory(this.content.category, "title", this.content.category);
    },
    categoryColor() {
      return getFromCategory(this.content.category, "color", this.color);
    },
    componentStyle() {
      return {
        "--background-color": this.authorized ? this.content.background_color : "var(--whitesmoke)"
      };
    }
  }
};
</script>

<template>
  <div class="mb-3 position-relative" :style="componentStyle" v-easyadmin="easyadminId" :class="contentType" tile-learning-component>
    <a class="position-absolute-center content-url cursor-pointer" :href="contentUrl" :target="getTarget(content.url)" v-if="authorized"></a>
    <a class="position-absolute-center content-url cursor-pointer" href="/users/sign_up" v-else></a>
    <div class="row tile-row">
      <div class="col-12 col-md-6 thumbnail position-relative">
        <div class="position-absolute-center w-100 h-100 px-3 pt-3 pt-md-4 info-container">
          <div v-if="content.category" class="px-3 px-md-4 text-white">
            <span :class="`bg-${categoryColor}`" class="category text-uppercase px-1 py-1 px-sm-2 py-md-2 font-sm m-0">{{categoryTitle}}</span>
          </div>
          <div class="position-absolute-center h-100 w-100 d-flex align-items-center justify-content-center">
            <span class="d-flex flex-column align-items-center" v-if="!authorized">
              <svg class="lock-icon text-white">
                <use xlink:href="#lock-icon"></use>
              </svg>
              <p class="text-uppercase text-white lock-text">Registrati e sblocca</p>
            </span>
            <span v-else-if="content.article_video">
              <svg class="play-icon text-white">
                <use xlink:href="#play-icon"></use>
              </svg>
            </span>
          </div>
        </div>
        <div class="position-absolute-center h-100 mx-3 overflow-hidden masking-background">
          <div class="bg-cover-center w-100 h-100 bg lazy-bg pt-3 pt-md-4" :lazy-src="getContentResponsiveImageURL('thumbnail')" :class="{'locked': !authorized}">
        </div>
        </div>
      </div>
      <div class="col-12 col-md-6">
        <div class="d-flex flex-column h-100 px-md-4 pt-3">
          <template v-if="content.title_composed || content.title">
            <div v-if="content.title_composed" class="title-composed">
              <h3 v-for="(titleLine, index) in content.title_composed" :class="getTitleStyle(titleLine)" class="h5 m-0" :key="index">{{titleLine.title}}</h3>
            </div>
            <h3 v-else class="h5 m-0 title-italic">{{content.title}}</h3>
          </template>
          <div v-if="content.description" v-html="content.description" class="pt-3"></div>
          <div class="mt-auto mb-3 d-flex align-items-center" v-if="owner">
            <div v-if="owner.avatar" class="avatar bg-cover-center mr-2 rounded-circle" :style="{'background-image': getBackgroundUrl(owner.avatar.url)}"></div>
            <div class="text-kenwood-dark-grey">
              By <strong>{{owner.username}}</strong>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
$icon-size: 2.625rem;

.content-url {
  z-index: 2;
}

.info-container {
  z-index: 1;
}

.masking-background {
  width: calc(100% - 2rem);
}

.locked {
  filter: blur(4px);
  background-color: rgba($black, .20);
  background-blend-mode: darken;
}

.thumbnail {
  min-height: 12.125rem;

  @include media-breakpoint-up(md) {
    min-height: 21.0625rem;
  }
}

.play-icon {
  width: $icon-size * 1.5;
  height: $icon-size * 1.5;
}

.lock-icon {
  width: $icon-size * 1.5;
  height: $icon-size * 1.5;
  fill: currentColor;
}

.lock-text {
  margin-top: 15px;
  font-weight: 500;
}

.avatar {
  width: $icon-size;
  height: $icon-size;
}

.tile-row {
  background: var(--background-color);
  background: linear-gradient(270deg, var(--background-color) 75%, transparent 100%);
}
</style>
